import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import GrowthEngine from "../components/GrowthEngine";

export default function GrowthEnginePage() {
  const { user, loading } = useAuth();
  if (loading) return <main className="max-w-6xl mx-auto px-4 py-20 text-slate-500">Loading…</main>;
  if (!user) return <Navigate to="/login?next=/growth" replace />;
  if (!user.is_admin && !user.is_staff) return <Navigate to="/dashboard" replace />;
  return <main className="max-w-6xl mx-auto px-4 sm:px-8 py-10" data-testid="growth-engine-page"><GrowthEngine /></main>;
}
